import React from "react";
import PropTypes from "prop-types";
import ErrorMessage from "../../../Component/ErrorMessage";
import SuccessMessage from "../../../Component/SuccessMessage";
import { useAlertContext } from "../../../Context/AlertContext";

const AuthAlerts = () => {
  const { successMessage } = useAlertContext();

  return (
    <>
      <ErrorMessage />
      <SuccessMessage message={successMessage} />
    </>
  );
};

export default AuthAlerts;
